import ArrowForward from '@mui/icons-material/ArrowForward'
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import whiteLockIcon from 'src/assets/white_lock.png'
import { PlayerContext } from 'src/consumer/context/PlayerContext'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { getDurationText } from 'src/consumer/helpers/dailyPlayHelper'
import { resetPlayerData } from 'src/consumer/helpers/playerHelper'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { GenericDisplayFlex } from 'src/mentor/layout/Styles'
import { getDataForPlanDayItem } from '../MyPlansPage/myplanhelpers'
import {
    CreatePlanInTileContainer,
    PlanInTileExternalContainer,
    ShowPlanInTileContainer,
    ShowPlanInTileInternalContainer,
    SPITMainItemDetailCategory,
    SPITMainItemDetailDescription,
    SPITMainItemDetailTitle,
    SPITMainItemPicture,
    SPITMainItemPictureAndDetailContainer,
    SPITMainItemPictureDayContainer,
    SPITMainItemPictureTopInfo,
    SPITMainItemStartButton,
    SPITOtherItem,
    SPITOtherItemDarkOverlay,
    SPITOtherItemLockContainer,
    SPITOtherItemPictureDayContainer,
    SPITOtherItemsContainer,
    SPITProgressContainer,
    SPITProgressFilled,
    SPITProgressHeading,
    SPITSectionOne,
    SPITSectionTwo,
} from './MyPlanCardStyles'

export const MyPlanCard = (props) => {
  const { cardsType, cardsCategory, cardsData } = props
  const navigate = useNavigate()
  const [mainItem, setMainItem] = useState()
  const { setupData } = useContext(SetupContext)
  const { playerData, setPlayerData } = useContext(PlayerContext)
  const [upcomingItems, setUpcomingItems] = useState([])
  const [doneItems, setDoneItems] = useState([])

  const getCompletionProgress = (items) => {
    let count = 0
    items?.forEach((item) => {
      if (item?.status === 'completed') {
        count++
      }
    })
    return (count / items?.length) * 100
  }

  const daysCompletedCount = cardsData?.[0]?.plan?.planItems?.reduce((count, item) => {
    if (item?.status === 'completed') {
      return count + 1
    }
    return count
  }, 0)

  useEffect(() => {
    const upcomingItems = []
    const doneItems = []
    cardsData?.[0]?.plan?.planItems?.forEach((item) => {
      if (item?.status !== 'completed') {
        upcomingItems?.push(getDataForPlanDayItem(item, setupData))
      } else {
        doneItems?.push(getDataForPlanDayItem(item, setupData))
      }
    })
    if (upcomingItems?.length > 0) {
      setMainItem(upcomingItems.shift())
    } else {
      setMainItem(doneItems.shift())
    }
    setUpcomingItems(upcomingItems)
    setDoneItems(doneItems)
  }, [])

  const otherItemsToList =
    upcomingItems?.length !== 0 ? upcomingItems.slice(0, 2) : doneItems.slice(-2)

  if (cardsData) {
    return (
      <PlanInTileExternalContainer>
        <ShowPlanInTileContainer>
          <GenericDisplayFlex style={{ gap: '10px', maxWidth: '100%', marginBottom: '20px' }}>
            <SPITProgressHeading style={{ textDecoration: 'none' }}>
              Your Progress
            </SPITProgressHeading>
            <SPITProgressContainer>
              <SPITProgressFilled
                progress={getCompletionProgress(cardsData?.[0]?.plan?.planItems)}
              />
            </SPITProgressContainer>
            <SPITProgressHeading small style={{ textDecoration: 'none' }}>
              {daysCompletedCount}/{cardsData?.[0]?.plan?.planItems?.length} Days
            </SPITProgressHeading>
          </GenericDisplayFlex>

          <ShowPlanInTileInternalContainer>
            <SPITSectionOne>
              <GenericDisplayFlex sb style={{ maxWidth: '100%', marginBottom: '20px' }}>
                <SPITProgressHeading>Today&apos;s Action</SPITProgressHeading>
              </GenericDisplayFlex>
              <SPITMainItemPictureAndDetailContainer>
                <SPITMainItemPicture
                  url={getImageLink(mainItem?.imgId)}
                  onClick={() => {
                    if (mainItem?.itemType === 'episode') {
                      setPlayerData({
                        ...resetPlayerData(playerData),
                        showPlayer: true,
                        selectedCard: playerData.showPIP
                          ? playerData?.selectedCard
                          : mainItem?.mainData,
                        source: 'plan',
                        id: mainItem?.id,
                        otherData: {
                          planId: mainItem?.id,
                          takeToMyPlan: true,
                          cardsData: cardsData,
                        },
                      })
                    }
                  }}
                >
                  <SPITMainItemPictureTopInfo>
                    {getDurationText(mainItem)}
                  </SPITMainItemPictureTopInfo>
                  <SPITMainItemPictureDayContainer>
                    Day {mainItem?.day}
                  </SPITMainItemPictureDayContainer>
                </SPITMainItemPicture>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    overflow: 'auto',
                  }}
                >
                  <div>
                    <SPITMainItemDetailTitle>{mainItem?.title}</SPITMainItemDetailTitle>
                    <GenericDisplayFlex
                      style={{ gap: '10px', flexShrink: 0, marginBottom: '10px' }}
                    >
                      <SPITMainItemDetailCategory>{mainItem?.category}</SPITMainItemDetailCategory>
                    </GenericDisplayFlex>
                    <SPITMainItemDetailDescription>
                      {mainItem?.description}
                    </SPITMainItemDetailDescription>
                  </div>
                  <SPITMainItemStartButton
                    onClick={() => {
                      if (mainItem?.itemType === 'episode') {
                        setPlayerData({
                          ...resetPlayerData(playerData),
                          showPlayer: true,
                          selectedCard: playerData.showPIP
                            ? playerData?.selectedCard
                            : mainItem?.mainData,
                          source: 'plan',
                          id: mainItem?.id,
                          otherData: {
                            planId: mainItem?.id,
                            takeToMyPlan: true,
                            cardsData: cardsData,
                          },
                        })
                      }
                    }}
                  >
                    Start
                    <ArrowForward sx={{ color: '#FFF', fontSize: 20 }} />
                  </SPITMainItemStartButton>
                </div>
              </SPITMainItemPictureAndDetailContainer>
            </SPITSectionOne>

            <SPITSectionTwo>
              <GenericDisplayFlex sb style={{ maxWidth: '100%', marginBottom: '20px' }}>
                <SPITProgressHeading>
                  {upcomingItems?.length > 0 ? 'Upcoming' : 'Previous'}
                </SPITProgressHeading>
                <SPITProgressHeading
                  small
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    navigate('/my-plan', {
                      state: {
                        cardsType: cardsType,
                        cardsCategory: cardsCategory,
                        cardsData: cardsData,
                      },
                    })
                  }
                >
                  See all
                </SPITProgressHeading>
              </GenericDisplayFlex>
              <SPITOtherItemsContainer>
                {otherItemsToList?.map((item, index) => {
                  return (
                    <SPITOtherItem
                      key={index}
                      imgLink={getImageLink(item?.imgId)}
                      clickable={upcomingItems?.length === 0}
                      onClick={() => {
                        if (upcomingItems?.length === 0) {
                          if (item?.itemType === 'episode') {
                            setPlayerData({
                              ...resetPlayerData(playerData),
                              showPlayer: true,
                              selectedCard: playerData.showPIP
                                ? playerData?.selectedCard
                                : item?.mainData,
                              source: 'plan',
                              id: item?.id,
                              otherData: {
                                planId: mainItem?.id,
                                takeToMyPlan: true,
                                cardsData: cardsData,
                              },
                            })
                          }
                        }
                      }}
                    >
                      <SPITOtherItemDarkOverlay>
                        <div>{item?.title}</div>
                        <div style={{ fontSize: '14px' }}>{getDurationText(item)}</div>
                      </SPITOtherItemDarkOverlay>
                      {upcomingItems?.length > 0 && (
                        <SPITOtherItemLockContainer>
                          <img src={whiteLockIcon} alt="locked" style={{ width: '70%' }} />
                        </SPITOtherItemLockContainer>
                      )}
                      <SPITOtherItemPictureDayContainer>
                        Day {item?.day}
                      </SPITOtherItemPictureDayContainer>
                    </SPITOtherItem>
                  )
                })}
              </SPITOtherItemsContainer>
            </SPITSectionTwo>
          </ShowPlanInTileInternalContainer>
        </ShowPlanInTileContainer>
      </PlanInTileExternalContainer>
    )
  } else {
    return (
      <PlanInTileExternalContainer>
        <CreatePlanInTileContainer
          onClick={() =>
            navigate('/my-plan/create', {
              state: { cardsType: cardsType, cardsCategory: cardsCategory, cardsData: cardsData },
            })
          }
        >
          Create a Plan
        </CreatePlanInTileContainer>
      </PlanInTileExternalContainer>
    )
  }
}
